// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"w8-z"};